import React, { Component, Fragment } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Table, Row, Col, Button, Icon, Tooltip } from 'antd'
import Detail from './Detail'
import _ from 'lodash'
// import IngredientsDetails from './IngredientsDetails'
import DrugCompaniesPopup from '@components/Popup/DrugCompaniesPopup'
import DrugAdditionalDataPopup from '@components/Popup/DrugAdditionalDataPopup'
import DrugFamiliesPopup from '@components/Popup/DrugFamilies'

@inject((store: any) => {
    const { popupStore, drugsStore } = store

    return { popupStore, drugsStore }
})
@observer
class List extends Component<any> {
    showDrugsCompanies = id => {
        const { popupStore, drugsStore } = this.props
        drugsStore.getDrug(id)
        popupStore.togglePopup('drugsCompanies')
    }

    showAdditionalDrugData = id => {
        const { popupStore, drugsStore } = this.props
        drugsStore.getDrug(id)
        popupStore.togglePopup('drugsAdditionalData')
    }

    render() {
        const {
            drugsStore: { list, families, paging, changePage, loading },
            popupStore: { togglePopup }
        } = this.props

        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                width: 50,
                align: 'center',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'שם',
                key: 'name',
                width: 500,
                align: 'center',
                render: (_, record) => (
                    <div>
                        {record.name ? (
                            <div>
                                <strong>שם בעברית - </strong>
                                <span>{record.name}</span>
                            </div>
                        ) : (
                            ''
                        )}
                        {record.name_en ? (
                            <div>
                                <strong>שם באנגלית - </strong>
                                <span>{record.name_en}</span>
                            </div>
                        ) : (
                            ''
                        )}
                        <a
                            style={{ textDecoration: 'underline' }}
                            onClick={() => {
                                this.props.drugsStore.setAliasesArray(record.aliases)
                                togglePopup('drugAliases', record)
                            }}
                        >
                            רשימת שמות מקבילים
                        </a>
                    </div>
                )
            },
            {
                title: 'משפחה/ות',
                key: 'families',
                width: 450,
                align: 'center',
                render: (_, record) => (
                    <>
                        {record.drugGroupDrugs.length < 2 ? (
                            <span>
                                {!record.drugGroupDrugs.length
                                    ? 'אין קישור למשפחה'
                                    : families.find(family => family.id == record.drugGroupDrugs[0].group_drug_id)
                                    ? families.find(family => family.id == record.drugGroupDrugs[0].group_drug_id).name
                                    : ''}
                            </span>
                        ) : (
                            <Detail
                                families={record.drugGroupDrugs.map(item => {
                                    return {
                                        name: families.find(family => family.id == item.group_drug_id)
                                            ? families.find(family => family.id == item.group_drug_id).name
                                            : ''
                                    }
                                })}
                            />
                        )}
                        <Icon
                            style={{ marginRight: 15 }}
                            type="plus"
                            onClick={() => togglePopup('DrugFamilies', record)}
                        />
                    </>
                )
            },

            {
                title: 'מס  רישום',
                key: 'registration_id',
                width: 150,
                align: 'center',
                render: (_, record) => <span>{record.registration_id}</span>
            },
            {
                title: 'בסל הבריאות',
                key: 'in_health_store',
                width: 150,
                align: 'center',
                render: (_, record) => <Icon type={record.in_health_store ? 'check' : 'close'} />
            },
            {
                title: 'מחירים',
                key: 'drugCompanies',
                width: 150,
                align: 'center',
                render: (_, record) => {
                    if (record.drugCompanies && record.drugCompanies.length > 0) {
                        return <Button onClick={() => this.showDrugsCompanies(record.id)}>מחירים</Button>
                    } else {
                        return <span>אין מידע</span>
                    }
                }
            },
            {
                title: 'מידע נוסף',
                key: '',
                width: 150,
                align: 'center',
                render: (_, record) => (
                    <Button onClick={() => this.showAdditionalDrugData(record.id)}>
                        <span style={{ textDecoration: 'underline' }}>מידע נוסף</span>
                    </Button>
                )
            }
        ]
        return (
            <Row>
                <Col>
                    <div className="box">
                        {list.length ? (
                            <Table
                                className="center-table"
                                style={{ width: '100%' }}
                                rowKey="id"
                                columns={columns}
                                loading={loading}
                                dataSource={list}
                                pagination={{
                                    total: paging.total,
                                    pageSize: paging.perPage,
                                    current: paging.page,
                                    onChange: value => changePage(value)
                                }}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                    <DrugCompaniesPopup />
                    <DrugAdditionalDataPopup />
                    <DrugFamiliesPopup />
                </Col>
            </Row>
        )
    }
}

export default withRouter(List)
